export default "__VITE_ASSET__DRQTm2MH__"